import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { PAGE_PROPS } from "../constants/common";
import { BALANCE_HISTORY_INITIAL_STATE } from "../constants/balanceHistory.constants";

export const getBalanceHistoryByUserId = createAsyncThunk(
  "balance/GetBalanceHistoryByUserId",
  async (userId: string) => {
    const response: any = await axios.get(
      "/api/Transaction/GetBalanceHistoryByUserId/" + userId
    );
    return response.data || response?.response?.data;
  }
);

export const getBalanceHistoryByTransactionId = createAsyncThunk(
  "balance/GetBalanceHistoryByTransactionId",
  async (transactionId: string) => {
    const response: any = await axios.get(
      "/api/Transaction/GetBalanceHistoryByTransactionId/" + transactionId
    );
    return response.data || response?.response?.data;
  }
);

export const balanceHistorySlice = createSlice({
  name: "balanceHistory",
  initialState: BALANCE_HISTORY_INITIAL_STATE,
  reducers: {
    onChangeBalanceHistoryList: (state, action) => {
      state.pageProps = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBalanceHistoryByUserId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBalanceHistoryByUserId.fulfilled, (state, action) => {
        state.loading = false;
        state.history = action.payload?.result ?? PAGE_PROPS;
      })
      .addCase(getBalanceHistoryByUserId.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getBalanceHistoryByTransactionId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBalanceHistoryByTransactionId.fulfilled, (state, action) => {
        state.loading = false;
        state.transactionHistory = action.payload?.result ?? [];
      })
      .addCase(getBalanceHistoryByTransactionId.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { onChangeBalanceHistoryList } = balanceHistorySlice.actions;

export default balanceHistorySlice.reducer;
